<template>
  <FormContainer>
    <template #title>Interruptions</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_periodeInterruption"
          v-model="periodeInterruptionModel"
          label="Y a-t-il des périodes d’interruption prévues ?"
          :required="meta.contrat?.periodeInterruption?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.periodeInterruption?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-12 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <!-- Liste les interruptions -->
        <template
          v-for="(item, index) in model?.contrat?.interruption ?? []"
          :key="index"
        >
          <WrapperInputDate
            id="field_50"
            v-bind:model-value="item.dateDebutInterruption"
            @update:model-value="(value) => updateInterruption('dateDebutInterruption', index, value)"
            label="Date de début d’interruption"
            :required="
              meta.contrat?.interruption?.at(index)?.dateDebutInterruption?.$status === PropertyStatus.Required
            "
            :alertLabel="meta.contrat?.interruption?.at(index)?.dateDebutInterruption?.$messageErreurDirty!"
            :hint="HINT_DATE"
            class="col-6 col-md-14 col-sm-36"
            :placeholder="PLACEHOLDER_DATE"
            deletable
            :readonly
          />
          <WrapperInputDate
            id="field_51"
            v-bind:model-value="item.dateFinInterruption"
            @update:model-value="(value) => updateInterruption('dateFinInterruption', index, value)"
            label="Date de fin d’interruption"
            :required="meta.contrat?.interruption?.at(index)?.dateFinInterruption?.$status === PropertyStatus.Required"
            :alertLabel="meta.contrat?.interruption?.at(index)?.dateFinInterruption?.$messageErreurDirty!"
            :hint="HINT_DATE"
            class="col-6 col-md-14 col-sm-36"
            :placeholder="PLACEHOLDER_DATE"
            deletable
            :readonly
          />
          <BasicButton
            v-if="supprimerVisible"
            id="field_52"
            variant="outlined"
            label="Supprimer"
            class="col-6 col-md-8 col-sm-36"
            icon-name="trash"
            @click="demandeSuppression(index)"
            :disabled="readonly"
          ></BasicButton>
        </template>
        <!-- Ajoute interruption -->

        <BasicButton
          v-if="periodeInterruptionModel"
          id="field_52"
          variant="outlined"
          label="Ajouter"
          class="col-6 col-md-8 col-sm-36"
          icon-name="add"
          @click="ajouterInterruption"
          :disabled="readonly"
        ></BasicButton>
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { InterruptionDTO } from '@/features/api/extranet/dto/Demande/CXPI'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { CXPI_INTERRUPTIONS_ACTIONS } from '@/features/interface/demande/cxpi/steps/contrat/useInterruptionsActions.ts'
  import { DEMANDE_STORE, FormContainer, HINT_DATE, PLACEHOLDER_DATE } from '@/features/interface/demande/shared'
  import { useDialog } from '@/features/interface/dialog'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { storeToRefs } from 'pinia'
  import { computed, inject } from 'vue'

  const dialog = useDialog()

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { setupArrayUpdaterWithKey, setupFieldWithKey } = store
  const { meta, model, readonly } = storeToRefs(store)

  const { ajouterInterruption, supprimerInterruption } = inject(CXPI_INTERRUPTIONS_ACTIONS)!

  const demandeSuppression = async (index: number) => {
    const response = await dialog.showDialog({
      title: 'Suppression interruption',
      message: 'Confirmez-vous la suppression de cette interruption ?',
      type: 'YesNo',
      closable: true,
    })
    if (response !== 'Yes') return
    await supprimerInterruption(index)
  }
  const periodeInterruptionModel = setupFieldWithKey<boolean>('contrat.periodeInterruption', false)
  const updateInterruption = setupArrayUpdaterWithKey<InterruptionDTO>('contrat.interruption')

  const supprimerVisible = computed<boolean>(() => model.value!.contrat!.interruption!.length > 1)
</script>
